import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-options.tsx
var LazyCourseOptions = lazy(() => import("./course-options-DJ2aouZ6.js").then((n) => n.n).then((module) => ({ default: module.CourseOptions })));
function CourseOptions({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-options" }),
		children: /* @__PURE__ */ jsx(LazyCourseOptions, { ...props })
	});
}
function CourseOptionsContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-options" }),
		children: /* @__PURE__ */ jsx(LazyCourseOptions, { ...props })
	});
}
var useCourseOptionsContent = () => {
	return useMemo(() => ({ courseOptions: { component: CourseOptionsContent } }), []);
};
//#endregion
export { CourseOptions, useCourseOptionsContent };
